export default "__VITE_ASSET__BxeLrans__"